"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVCard = exports.validatePhone = exports.validateUrl = exports.mergeCustomisation = exports.mergeVCard = void 0;
const mergeVCard = (vCard, type, value) => {
    switch (type) {
        case 'company':
            return Object.assign(Object.assign({}, vCard), { company: value });
        case 'address':
            return Object.assign(Object.assign({}, vCard), { address: { house: value, type: 'HOME' } });
        case 'website':
            return Object.assign(Object.assign({}, vCard), { website: value });
        case 'birthday':
            return Object.assign(Object.assign({}, vCard), { dateOfBirth: value });
        case 'firstname':
            return Object.assign(Object.assign({}, vCard), { firstName: value });
        case 'lastname':
            return Object.assign(Object.assign({}, vCard), { lastName: value });
        case 'phone':
            return Object.assign(Object.assign({}, vCard), { phone: value });
        case 'email':
            return Object.assign(Object.assign({}, vCard), { email: value });
        case 'job-title':
            return Object.assign(Object.assign({}, vCard), { jobTitle: value });
        default:
            return vCard;
    }
};
exports.mergeVCard = mergeVCard;
const mergeCustomisation = (data, type, value) => {
    switch (type) {
        case 'background':
            return Object.assign(Object.assign({}, data), { background: value.toString() });
        case 'qrcode':
            return Object.assign(Object.assign({}, data), { foreground: value.toString() });
        case 'margin':
            return Object.assign(Object.assign({}, data), { padding: Number(value) });
        case 'image':
            return Object.assign(Object.assign({}, data), { image: data.image
                    ? Object.assign(Object.assign({}, data.image), { url: value }) : {
                    url: value,
                    width: '20%',
                    height: '20%',
                } });
        case 'margin-logo':
            return Object.assign(Object.assign({}, data), { image: Object.assign(Object.assign({}, data.image), { border: Number(value) }) });
        default:
            return data;
    }
};
exports.mergeCustomisation = mergeCustomisation;
function validateUrl(url) {
    if (url === undefined || url === '') {
        return null;
    }
    const regexp = /^(https?:\/\/)?([^\s$.?#].[^\s]*)$/g;
    return regexp.test(url);
}
exports.validateUrl = validateUrl;
function validatePhone(phone) {
    if (phone === undefined || phone === '') {
        return null;
    }
    const regexp = new RegExp('^[0-9\\-()+ ]*$');
    return regexp.test(phone);
}
exports.validatePhone = validatePhone;
function validateVCard(vCard) {
    return (vCard &&
        Object.values(vCard).some(Boolean) &&
        validatePhone(vCard.phone) !== false);
}
exports.validateVCard = validateVCard;
//# sourceMappingURL=qrcode.utils.js.map